export const _ErrorMessages = {
  required: 'Field is required',
  validEmail: 'Please key in a valid email',
  needToMatch: 'Passwords need to match',
  weakPassword: 'Password is too weak',
  emailAlreadyExists: 'Email already exists',
  invalidPhoneNumber: 'Invalid mobile number, 8 digits only',
  invalidPostalCode: 'Invalid postal code'
};
